import React , { Component } from 'react';

import {injectIntl} from 'react-intl';
import RegistryLogo from './RegistryLogo';
import Radium, { Style } from 'radium';

class Footer extends Component {

  render() {
    
    const currentYear = new Date().getFullYear();

    return (
      <footer className="container-fluid footer-pf-alt" >
          <Style scopeSelector=".footer-pf-alt" rules={{
              backgroundColor: '#004368',
              marginTop: '20px',
              textAlign: 'center',
              color: 'white',
              fontSize: "120%",

              'span, a': {
                  color: 'white'
              },

              'li': {
                  marginLeft: '20px'
              },

              'a:hover': {
                  'textDecoration': 'none'
              }

          }} />
        <ul className="list-inline">
          <li>© {currentYear} <a href="http://www.nic.it">Registro<RegistryLogo style={{ height: "25px" }}/></a></li>
        </ul>
      </footer>
    )
  }
}

export default Radium(injectIntl(Footer));



// WEBPACK FOOTER //
// ./src/components/Footer.js